import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
});

// Servicio smartpay-reports: plantillas, catalogo y ejecucion (/run) de los reportes legacy. Usa la misma
// REACT_APP_API_REPORTS_URL que ya usa api/Orders.jsx; si no esta definida cae al backend principal, que
// sigue exponiendo las mismas rutas. Las exportaciones a Excel (exportExcel / exportLegacyExcel) siguen
// yendo siempre al backend principal (`server`): reports no las implementa. Reports tampoco ejecuta
// plantillas METRICS (501).
const reportsServer = axios.create({
    baseURL: process.env.REACT_APP_API_REPORTS_URL || process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
});

export class ReportTemplatesAPI {
    static async getTemplates(token, business_code) {
        const res = await reportsServer('/report-templates', {
            method: 'GET',
            params: business_code ? { business_code } : undefined,
            headers: { 'x-access-token': token }
        });
        return res;
    }

    static async createTemplate(data, token) {
        const res = await reportsServer('/report-templates', {
            method: 'POST',
            data,
            headers: { 'x-access-token': token }
        });
        return res;
    }

    static async updateTemplate(id, data, token) {
        const res = await reportsServer(`/report-templates/${id}`, {
            method: 'PUT',
            data,
            headers: { 'x-access-token': token }
        });
        return res;
    }

    static async deleteTemplate(id, token) {
        const res = await reportsServer(`/report-templates/${id}`, {
            method: 'DELETE',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    static async exportExcel(data, token) {
        const res = await server('/report-panel/export/excel', {
            method: 'POST',
            data,
            responseType: 'blob',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    static async getSmartpayCatalog(token) {
        const res = await reportsServer('/report-templates/smartpay-catalog', {
            method: 'GET',
            headers: { 'x-access-token': token }
        });
        return res;
    }

    static async runTemplate(id, data, token) {
        const res = await reportsServer(`/report-templates/${id}/run`, {
            method: 'POST',
            data,
            headers: { 'x-access-token': token }
        });
        return res;
    }

    static async exportLegacyExcel(id, data, token) {
        const res = await server(`/report-templates/${id}/export-legacy-excel`, {
            method: 'POST',
            data,
            responseType: 'blob',
            headers: { 'x-access-token': token }
        });
        return res;
    }
}
